import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Typography,
    CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IoIosAlert } from "react-icons/io";

const ActionConfirmationModal = ({ 
    open, 
    onClose, 
    onConfirm, 
    title = "Confirmation", 
    message = "Are you sure you want to continue?", 
    isProcessing = false 
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box display={'flex'} alignItems="center" gap={1}>
                    <IoIosAlert style={{ color: 'rgba(232, 108, 0, 1)', fontSize: "23px" }} />
                    <Typography sx={{ color: 'var(--text-1)', fontSize: "20px", fontWeight: "600" }}>
                        {title}
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: 'rgba(144, 152, 161, 0.7)',
                        padding: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(144, 152, 161, 0.1)',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
                <Typography sx={{ fontSize: "16px", color: 'var(--text-1)', opacity: 0.8 }}>
                    {message}
                </Typography>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 2 }}>
                <Button
                    onClick={onClose}
                    disabled={isProcessing}
                    sx={{
                        border: "1px solid var(--border-1)",
                        color: "var(--text-2)",
                        borderRadius: "4px",
                        textTransform: "none",
                        px: 3,
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    disabled={isProcessing}
                    sx={{
                        backgroundColor: 'rgba(232, 108, 0, 1)',
                        '&:hover': {
                            backgroundColor: 'rgba(232, 108, 0, 0.8)',
                        },
                        borderRadius: '4px',
                        textTransform: "none",
                        px: 3,
                        minWidth: "100px",
                    }}
                >
                    {isProcessing ? <CircularProgress size={20} color="inherit" /> : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ActionConfirmationModal;
